module.exports = __webpack_public_path__ + "img/bg_namako.5c1cb75f.svg";